import {
  LanguageRouting, Router, Route, LanguageProvider,
} from '@ipc/ipc-core';
import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import AppContainer from './application/AppContainer';
import { defaultLanguage, supportedLanguages } from '../locales/locales';

function languageRouting() {
  return props => <LanguageRouting {...props} AppContainer={AppContainer} />;
}

export class Root extends React.Component {
  render = () => {
    const { store } = this.props;
    return (
      <LanguageProvider supportedLanguages={supportedLanguages} defaultLanguage={defaultLanguage}>
        <Provider store={store}>
          <Router basename={process.env.basePath}>
            <Route render={languageRouting()} />
          </Router>
        </Provider>
      </LanguageProvider>
    );
  };
}

Root.propTypes = {
  store: PropTypes.objectOf(PropTypes.shape),
};

export default Root;
